<template>
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21" cy="21" r="21" fill="#EBF1F3" />
    <path
      d="M16 17C16 14.2386 18.2386 12 21 12C23.7614 12 26 14.2386 26 17C26 19.7614 23.7614 22 21 22C18.2386 22 16 19.7614 16 17ZM21 20C22.6569 20 24 18.6569 24 17C24 15.3431 22.6569 14 21 14C19.3431 14 18 15.3431 18 17C18 18.6569 19.3431 20 21 20Z"
      fill="currentColor"
    />
    <path
      d="M15.3431 25.3431C13.8429 26.8434 13 28.8783 13 31H15C15 29.4087 15.6321 27.8826 16.7574 26.7574C17.8826 25.6321 19.4087 25 21 25C22.5913 25 24.1174 25.6321 25.2426 26.7574C26.3679 27.8826 27 29.4087 27 31H29C29 28.8783 28.1571 26.8434 26.6569 25.3431C25.1566 23.8429 23.1217 23 21 23C18.8783 23 16.8434 23.8429 15.3431 25.3431Z"
      fill="currentColor"
    />
  </svg>
</template>
